import { render } from "./UploadField.vue?vue&type=template&id=a81a40b2"
import script from "./UploadField.vue?vue&type=script&lang=js"
export * from "./UploadField.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__